import eventOverview, { eventOverviewTable } from './eventOverview'

export const rosterOverviewTable = eventOverviewTable

export default (opts = {}) => eventOverview({
  ...opts,
  resource: 'rosters',
  refreshMethod: 'refreshRosterRows',
  historyKey: 'roster',
  deduplicateCursorRows: true
})
